<mat-card>
    <mat-card-title>Weight Set</mat-card-title>
    <mat-card-content>
        <form [formGroup]="weightSet" class="weight-set-entry-container">
            <mat-form-field class="weight-set-entry">
                <mat-label>Name</mat-label>
                <input matInput
                    formControlName="name"
                    [matAutocomplete]="auto" 
                 />
                 <mat-autocomplete #autoComplete #auto="matAutocomplete" panelWidth="400px">
                    <mat-option *ngFor="let name of recommendedSets | async" [value]="name">
                        {{name}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <div class="input-with-button-group">
                <mat-form-field class="weight-set-entry">
                    <mat-label>Weight</mat-label>
                    <input matInput required type="number" min="0" matInput formControlName="weight">
                </mat-form-field>
                <button mat-icon-button color="primary" id="weight-edit-button" (click)="calculateWeight()"><mat-icon>ballot</mat-icon></button>
            </div>
            <mat-form-field class="weight-set-entry">
                <mat-label>Reps</mat-label>
                <input matInput required type="number" min="0" matInput formControlName="reps">
            </mat-form-field>
            <mat-form-field class="weight-set-entry" [style.display]="this.id ? 'none' : ''">
                <mat-label>Repeated</mat-label>
                <input matInput required type="number" min="1" matInput formControlName="repeated">
            </mat-form-field>
            <mat-form-field class="weight-set-entry">
                <mat-label>When</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="when">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </form>
        <button mat-raised-button color="accent" (click)="save()">Save</button>
    </mat-card-content>
</mat-card>